import { render } from "./MatchDetails.vue?vue&type=template&id=3dee0e74&scoped=true"
import script from "./MatchDetails.vue?vue&type=script&lang=js"
export * from "./MatchDetails.vue?vue&type=script&lang=js"

import "./MatchDetails.vue?vue&type=style&index=0&id=3dee0e74&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dee0e74"]])

export default __exports__